import styled from "styled-components";

const StyledLogo = styled.div`
  flex-grow: 1;
  height: 3.75rem;
`;

export default StyledLogo;
